import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import Icon from "../Icon";
import MainContainer from "../MainContainer";
import UserBar from "./UserBar";
import LanguageBar from "./LanguageBar";
import NavBar from "../NavBar";
import styles from "./Header.module.scss";
import withTheme from "../../libs/themr/withTheme";

const Header = ({
  className,
  theme,
  children,
  mainLogo,
  secondaryLogo,
  onMobileMenuClick,
  homeUrl,
  handleLinkClick
}) => {
  let userBar = null;
  let languageBar = null;
  let navBar = null;

  React.Children.forEach(children, child => {
    if (child?.type === UserBar) {
      userBar = child;
    }
    if (child?.type === LanguageBar) {
      languageBar = child;
    }
    if (child?.type === NavBar) {
      navBar = child;
    }
  });

  return (
    <header className={cx(className, theme.header)}>
      <div className={theme.topBar}>
        <MainContainer theme={theme} className={theme.topBarContainer}>
          {languageBar}
          {userBar}
        </MainContainer>
      </div>
      <div className={theme.brand}>
        <MainContainer theme={theme}>
          <a
            href={homeUrl}
            className={theme.mainLogo}
            onClick={event => handleLinkClick(event, homeUrl, "_self", true)}
          >
            <img src={mainLogo.src} title={mainLogo.title || ""} alt={mainLogo.title || ""} />
          </a>
          {navBar}
          <span className={theme.secondaryLogo}>
            <img src={secondaryLogo.src} title={secondaryLogo.title || ""} alt={secondaryLogo.title || ""} />
          </span>
          <button type="button" onClick={onMobileMenuClick} className={theme.burgerButton}>
            <Icon className={theme.icon} icon="burger" />
          </button>
        </MainContainer>
      </div>
    </header>
  );
};

Header.defaultProps = {
  className: "",
  children: null,
  homeUrl: "/",
  handleLinkClick: () => {}
};

Header.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  secondaryLogo: PropTypes.shape({
    src: PropTypes.string.isRequired,
    title: PropTypes.string
  }).isRequired,
  mainLogo: PropTypes.shape({
    src: PropTypes.string.isRequired,
    title: PropTypes.string
  }).isRequired,
  onMobileMenuClick: PropTypes.func.isRequired,
  homeUrl: PropTypes.string,
  theme: PropTypes.object.isRequired,
  handleLinkClick: PropTypes.func
};

export default withTheme(styles)(React.memo(Header));
